import { render, staticRenderFns } from "./mcs-action-card.vue?vue&type=template&id=55b00c4a&scoped=true&"
import script from "./mcs-action-card.vue?vue&type=script&lang=js&"
export * from "./mcs-action-card.vue?vue&type=script&lang=js&"
import style0 from "./mcs-action-card.vue?vue&type=style&index=0&id=55b00c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b00c4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
